import axios from './axios';
import { Vehicle, VehicleStopPurpose, VehicleStopType } from '../store/config/types';

async function fetchVehicles(include?: string[], noUnAvailables?: boolean): Promise<Vehicle[] | undefined> {
  const params = new URLSearchParams();
  if (noUnAvailables) {
    params.append('noUnAvailables', 'true');
  }
  include?.forEach((entity) => params.append('join', entity));
  const res = await axios.get(`/vehicles?${params.toString()}`);
  const vehicles: Vehicle[] = res.data.data;
  vehicles.sort((v1, v2) => {
    if (v1.displayName && v2.displayName) {
      return v1.displayName.localeCompare(v2.displayName);
    } else if (v1.displayName) {
      return -1;
    } else if (v2.displayName) {
      return 1;
    }
    return 0;
  });
  return vehicles;
}

async function fetchVehicle(vehicleId: number): Promise<Vehicle | undefined> {
  const res = await axios.get('/vehicles/' + vehicleId);
  return res.data.data;
}

async function createVehicle(vehicle: Vehicle): Promise<Vehicle | undefined> {
  const res = await axios.post('/vehicles', vehicle);
  return res.data.data;
}

async function updateVehicle(vehicleId: number, vehicle: Vehicle): Promise<Vehicle | undefined> {
  const res = await axios.patch('/vehicles/' + vehicleId, vehicle);
  return res.data.data;
}

async function deleteVehicle(vehicleId: number): Promise<boolean | undefined> {
  const res = await axios.delete('/vehicles/' + vehicleId);
  return res.data.data;
}

async function identifyVehicleStop(
  vehicleStopId: number,
  type?: VehicleStopType,
  purpose?: VehicleStopPurpose,
  additionalData?: any,
) {
  const res = await axios.patch(`/vehicles/identify-stop/${vehicleStopId}`, { type, purpose, additionalData });
  return res.data.data;
}

export const VehiclesService = {
  fetchVehicles,
  fetchVehicle,
  createVehicle,
  updateVehicle,
  deleteVehicle,
  identifyVehicleStop,
};
